import { Box, Text } from '@chakra-ui/react';
import { Color } from 'presentation/theme/colorScheme';
import { FC } from 'react';

interface Props {
  progress: PeAssetProgress;
}

const PeOffersGridItemProgress: FC<Props> = ({ progress }) => {
  return (
    <Box pos="relative" h="32px">
      <Box
        w="100%"
        h="15px"
        bgColor="#D9D9D9"
        borderRadius="6px"
        left="0"
        top="9px"
        position="absolute"
      />
      <Box
        position="absolute"
        w={`${progress.value}%`}
        h="15px"
        bgColor={Color.Primary500}
        borderRadius="6px"
        left="0"
        top="9px"
      />
      <Box
        position="absolute"
        bgColor={Color.Primary500}
        borderRadius="17px"
        px="8px"
        py="5px"
        left={progress.value < 93 ? progress.value >= 10 ? `calc(${progress.value}% - 30px)` : '0' : undefined}
        right={progress.value >= 93 ? '0' : undefined}
        top="0"
      >
        <Text fontSize="18px" fontWeight={700} color="#fff">
          {progress.value}%
        </Text>
      </Box>
    </Box>
  );
};

export default PeOffersGridItemProgress;
